export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_scale_white@3x.f8931cff.jpg";